import { Container } from "reactstrap"
import { useTranslation } from "react-i18next"
import Slider from "react-slick"
import AvisIcon from "../../images/avis/AvisClient.png"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { FaStar } from "react-icons/fa"

const AvisClient = () => {
  const { t } = useTranslation()

  const testimonials = [
    { name: "Guillaume C.", key: "avisclients|avisGuillaume" },
    { name: "Frédéric B.", key: "avisclients|avisFrederic" },
    { name: "Martin B.", key: "avisclients|avisMartin" },
    { name: "Teddy P.", key: "avisclients|avisTeddy" }
  ]

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    adaptiveHeight: true
  }



  const renderStars = () => {
    return Array.from({ length: 5 }, (_, i) => (
      <FaStar key={i} className="text-warning" />
    ))
  }

  return (
    <div className="py-5 mb-5">
      <Container>
        <h2 className="mb-5 text-center dark-blue">{t("avisclients|Témoignages clients")}</h2>
        <Slider {...settings}>
          {testimonials.map((avis, index) => (
            <div key={index} className="text-center px-3">
              <img
                src={AvisIcon}
                alt="Avis"
                style={{
                  display: "block",
                  margin: "0 auto 20px",
                  height: "80px"
                }}
              />
              <p>{avis.name}</p>
              <div style={{ color: "#FFD700", fontSize: "1.5rem" }}>{renderStars()}</div>
              <p
                className="mt-2 mb-3"
                style={{
                  maxWidth: "600px",
                  margin: "auto",
                  whiteSpace: "pre-line",
                  fontSize: "14px"
                }}
              >
                {t(avis.key)}
              </p>
            </div>
          ))}
        </Slider>
      </Container>
    </div>
  )
}

export default AvisClient
